import { userType } from "../type";
import { passwordEdit, userDelete, userEdit, userList, userRegister } from "../../api";


export const userListAction = (formData) => async (dispatch) => {
    try {
        const { data } = await userList(
            formData || {
                page_no: 1,
                limit: 100,
            }
        );
        dispatch({
            type: userType.GET_ALL_USER,
            payload: data,
        });
    } catch (error) {
        // console.log(error);
        dispatch({
            type: userType.ERROR,
            payload: error,
        });
    }
};
export const addUserAction = (formData) => async (dispatch) => {
    try {

        const { data } = await userRegister(formData);
        // console.log("🚀 ~ addUserAction ~ data:", data)
        if (data.status === 200) {
            dispatch({
                type: userType.ADD_USER,
                payload: data,
            });
        }
        dispatch({
            type: userType.MESSAGE,
            payload: data.message,
        });
    } catch (error) {
        // console.log(error);
        dispatch({
            type: userType.ERROR,
            payload: error,
        });
    }
};

export const updateUserAction = (formData, userId) => async (dispatch) => {
    try {
      const response = await userEdit(formData);
      
  
      if (response.data && response.data.data) {
        const { eisId, email, firstname, lastname, role, status, subareaId, userId: responseUserId } = response.data.data;
        const updatedAt = new Date().toISOString();
        const data = {
          eisId,
          email,
          firstname,
          lastname,
          role,
          status,
          subareaId,
          _id: responseUserId,
          updatedAt
        };

        if (response.status === 200) {
          dispatch({
            type: userType.UPDATE_USER,
            payload: { userId, data },
          });
        } else {
          dispatch({
            type: userType.MESSAGE,
            payload: response.data.message,
          });
        }
      } else {
        // Handle missing data
        dispatch({
          type: userType.ERROR,
          payload: "Invalid response structure",
        });
      }
    } catch (error) {
      dispatch({
        type: userType.ERROR,
        payload: error.message || "An error occurred",
      });
    }
  };
  

export const updatePasswordAction = (formData) => async (dispatch) => {

    try {
        const { data } = await passwordEdit({
            userId: formData.userId,
            password: formData.password,
        });
        dispatch({
            type: userType.CHANGE_PASSWORD,
            payload: { ...data },
        });
    } catch (error) {
        // console.log(error);
        dispatch({
            type: userType.ERROR,
            payload: error,
        });
    }
};
export const deleteUserAction = (userId) => async (dispatch) => {
    try {
        const { data } = await userDelete({
            id: userId,
        });

        if (data.status === 200) {
            dispatch({
                type: userType.DELETE_USER,
                payload: { userId, message: data.message }
            });
        } else {
            dispatch({
                type: userType.MESSAGE,
                payload: "You Can't able to Delete User"
            });
        }

    } catch (error) {
        // console.log(error);
        dispatch({
            type: userType.ERROR,
            payload: error,
        });
    }
};
